import React from 'react';
import Widgets from './action-widgets/widgets.jsx';
import { connect } from 'react-redux';

const SingleProduct = ({ productName, applyAll, noBottomBorder, ratePackageName, ...extraProps }) => {
  return (
    <div style={{ paddingLeft: '16px', paddingRight: '16px' }}>
      <div style={{ fontSize: '12px', textTransform: 'uppercase', paddingLeft: '16px', borderBottom: noBottomBorder ? 'none' : 'solid 1px #eeeeee', lineHeight: '61px' }}>
        { applyAll ?
          <div style={{ width: '30%', color: 'rgba(0, 0, 0, 0.87)', display: 'inline-block' }}>APPLY ALL</div> :
          <div style={{ width: '30%', display: 'inline-block', lineHeight: '14px', verticalAlign: 'middle' }}>{productName}{ratePackageName ? ` - ${ratePackageName}` : ''}</div>
        }
        <div style={{ width: '70%', display: 'inline-block' }}>
          <Widgets applyAll={applyAll} {...extraProps} />
        </div>
      </div>
    </div>
  );
};

export default SingleProduct;



// WEBPACK FOOTER //
// ./src/app/components/contracting/mass-rate-change/middle-action-area/products/single-product.jsx